export default {
  props: {
    isSubmittable: { type: Boolean, default: true },
  },
  model: {
    prop: 'isSubmittable',
    event: 'change',
  },
  data() {
    return {
      hasChanged: false,
      error: {
        message: '',
      },
    }
  },
  methods: {
    validate() {
      return true
    },
    onChange() {
      this.hasChanged = true
      this.$emit('change', this.validate())
    },
    handleError(err) {
      if (!err.graphQLErrors) {
        this.error.message = err.message
        return
      }
      for (let error of err.graphQLErrors) {
        this.error.message = error.message || error.messages.join('\n')
      }
    },
  },
  mounted() {
    this.$emit('change', this.validate())
  },
}
